import React, { useState } from "react";
import classes from "./component/common-navBar/CommonNavBar.module.css";

export interface PersonalTaxImgProps {
  stroke?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
  iconName?: string;
  hoverStroke?: string;
}

const PersonalTaxImage: React.FC<PersonalTaxImgProps> = (props) => {
  const { width = "14", height = "12", strokeWidth = "1.5px", hoverStroke = "", iconName } = props;
  const ReturnIcon = ({ iconNameVal }) => {
    if (iconNameVal === "Personal Tax") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: "-4px", marginLeft: "0px" }}>
          <circle cx="4.5" cy="2.5" r="1.85" style={{ strokeWidth: 1.3 }} />
          <path
            d="M0.65 8C0.65 7.25442 1.25442 6.65 2 6.65H7C7.74558 6.65 8.35 7.25442 8.35 8V11.35H0.65V8Z"
            style={{ strokeWidth: 1.3 }}
          />
          <rect
            x="17.625"
            y="2.375"
            width="0.75"
            height="6.25"
            rx="0.375"
            transform="rotate(90 17.625 2.375)"
            style={{ strokeWidth: 0.75 }}
          />
          <rect
            x="17.625"
            y="6.375"
            width="0.75"
            height="6.25"
            rx="0.375"
            transform="rotate(90 17.625 6.375)"
            style={{ strokeWidth: 0.75 }}
          />
          <rect
            x="17.625"
            y="10.375"
            width="0.75"
            height="6.25"
            rx="0.375"
            transform="rotate(90 17.625 10.375)"
            style={{ strokeWidth: 0.75 }}
          />
        </svg>
      );
    }
    if (iconNameVal === "AccountantOveview") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginLeft: "1px" }}>
          <rect
            x="0.6"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="0.6"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
        </svg>
      );
    }

    if (iconNameVal === "Overview") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginLeft: "1px" }}>
          <rect
            x="0.6"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="0.6"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
        </svg>
      );
    }

    if (iconNameVal === "ServiceManagerOverview") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginLeft: "1px" }}>
          <rect
            x="0.6"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="0.6"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
        </svg>
      );
    }

    if (iconNameVal === "AccountantSettings") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: "-4px", marginLeft: "-2px" }}>
          <path
            d="M16.1763 7.21189H14.6794C14.4388 7.21189 14.2406 7.08607 14.1484 6.87496C14.0563 6.66385 14.1031 6.44148 14.2729 6.27991L15.3313 5.27474C15.4868 5.12696 15.5724 4.9302 15.5724 4.72134C15.5724 4.5122 15.4868 4.31573 15.3313 4.16767L13.9822 2.88608C13.6711 2.59053 13.1286 2.58997 12.8169 2.88608L11.7588 3.89126C11.5887 4.05254 11.3541 4.09758 11.1324 4.00976C10.9102 3.92222 10.7778 3.73391 10.7778 3.50534V2.0833C10.7778 1.65179 10.4083 1.30078 9.95407 1.30078H8.04593C7.5917 1.30078 7.22222 1.65179 7.22222 2.0833V3.50534C7.22222 3.73391 7.08978 3.92222 6.86756 4.00976C6.64593 4.09786 6.41126 4.05254 6.24119 3.89126L5.18311 2.88608C4.87141 2.58997 4.32889 2.59053 4.01778 2.88608L2.66874 4.16767C2.51319 4.31545 2.42756 4.5122 2.42756 4.72134C2.42756 4.9302 2.51319 5.12668 2.66874 5.27474L3.72711 6.27991C3.89689 6.44148 3.94341 6.66385 3.85156 6.87496C3.7597 7.08607 3.56119 7.21189 3.32059 7.21189H1.8237C1.36948 7.21189 1 7.5629 1 7.99441V9.80687C1 10.2387 1.36948 10.5897 1.8237 10.5897H3.32059C3.56119 10.5897 3.75941 10.7155 3.85156 10.9266C3.9437 11.1377 3.89689 11.3601 3.72711 11.5217L2.66874 12.5268C2.51319 12.6746 2.42756 12.8714 2.42756 13.0802C2.42756 13.2894 2.51319 13.4858 2.66874 13.6339L4.01778 14.9155C4.32919 15.2113 4.87141 15.2119 5.18311 14.9155L6.24119 13.91C6.41126 13.7487 6.64504 13.7043 6.86756 13.7918C7.08978 13.8793 7.22222 14.0677 7.22222 14.2962V15.7183C7.22222 16.1498 7.5917 16.5008 8.04593 16.5008H9.95378C10.408 16.5008 10.7775 16.1498 10.7775 15.7183V14.2962C10.7775 14.0677 10.9099 13.8793 11.1321 13.7918C11.3547 13.704 11.5884 13.7487 11.7585 13.91L12.8166 14.9155C13.1283 15.2116 13.6708 15.211 13.9819 14.9155L15.331 13.6339C15.4865 13.4861 15.5721 13.2894 15.5721 13.0802C15.5721 12.8714 15.4865 12.6749 15.331 12.5268L14.2726 11.5217C14.1028 11.3601 14.0563 11.1377 14.1481 10.9266C14.24 10.7155 14.4388 10.5897 14.6794 10.5897H16.1763C16.6305 10.5897 17 10.2387 17 9.80715V7.99441C17 7.5629 16.6305 7.21189 16.1763 7.21189ZM16.4074 9.80715C16.4074 9.92819 16.3037 10.0267 16.1763 10.0267H14.6794C14.1982 10.0267 13.7849 10.289 13.6009 10.7113C13.4166 11.1335 13.5135 11.5968 13.8539 11.92L14.9123 12.9251C15.0027 13.011 15.0027 13.1503 14.9123 13.2359L13.5633 14.5175C13.4732 14.603 13.3265 14.6036 13.2361 14.5175L12.1781 13.512C11.8376 13.1886 11.3502 13.0971 10.9058 13.2716C10.4613 13.4464 10.1852 13.8391 10.1852 14.2962V15.7183C10.1852 15.8393 10.0815 15.9378 9.95407 15.9378H8.04593C7.91852 15.9378 7.81482 15.8393 7.81482 15.7183V14.2962C7.81482 13.8391 7.53867 13.4464 7.09422 13.2716C6.94519 13.2128 6.7917 13.1841 6.64 13.1841C6.33956 13.1841 6.0483 13.2967 5.82193 13.5117L4.76385 14.5172C4.67319 14.6033 4.52652 14.6028 4.43674 14.5172L3.0877 13.2356C2.99733 13.1497 2.99733 13.0104 3.0877 12.9248L4.14607 11.9197C4.48622 11.5965 4.58341 11.1332 4.39911 10.711C4.21511 10.289 3.80178 10.0267 3.32059 10.0267H1.8237C1.6963 10.0267 1.59259 9.92819 1.59259 9.80715V7.99441C1.59259 7.87337 1.6963 7.77486 1.8237 7.77486H3.32059C3.80178 7.77486 4.21511 7.51251 4.39911 7.09029C4.58341 6.66807 4.48652 6.20475 4.14607 5.88161L3.0877 4.87644C2.99733 4.79059 2.99733 4.65126 3.0877 4.56568L4.43674 3.2841C4.52681 3.19825 4.67348 3.19825 4.76385 3.2841L5.82193 4.28927C6.16178 4.61213 6.64919 4.70474 7.09422 4.52966C7.53867 4.35514 7.81482 3.96247 7.81482 3.50534V2.0833C7.81482 1.96226 7.91852 1.86374 8.04593 1.86374H9.95378C10.0815 1.86374 10.1852 1.96226 10.1852 2.0833V3.50534C10.1852 3.96247 10.4613 4.35514 10.9058 4.52994C11.3508 4.70502 11.8379 4.61269 12.1781 4.28955L13.2361 3.28438C13.3268 3.19853 13.4735 3.19853 13.5633 3.28438L14.9123 4.56597C15.0027 4.65182 15.0027 4.79115 14.9123 4.87672L13.8539 5.88189C13.5138 6.20503 13.4166 6.66835 13.6009 7.09057C13.7849 7.5128 14.1982 7.77514 14.6794 7.77514H16.1763C16.3037 7.77486 16.4074 7.87337 16.4074 7.99441V9.80715Z"
            fill="#545454"
            style={{ strokeWidth: "0.4" }}
          />
          <path
            d="M8.99992 6.36719C7.5294 6.36719 6.33325 7.50353 6.33325 8.90052C6.33325 10.2975 7.5294 11.4339 8.99992 11.4339C10.4704 11.4339 11.6666 10.2975 11.6666 8.90052C11.6666 7.50353 10.4704 6.36719 8.99992 6.36719ZM8.99992 10.8709C7.85651 10.8709 6.92584 9.98676 6.92584 8.90052C6.92584 7.81428 7.85651 6.93015 8.99992 6.93015C10.1433 6.93015 11.074 7.81428 11.074 8.90052C11.074 9.98676 10.1433 10.8709 8.99992 10.8709Z"
            fill="#545454"
            style={{ strokeWidth: "0.4" }}
          />
        </svg>
      );
    }
    if (iconNameVal === "LimitedCompany") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: "-5.5px", marginLeft: "-2px" }}>
          <path
            d="M3.6 15V7.60389L10.71 6.09825C11.5806 5.91389 12.4 6.57796 12.4 7.46788V16.4H5C4.2268 16.4 3.6 15.7732 3.6 15Z"
            style={{ strokeWidth: 1.2 }}
          />
          <path
            d="M0.6 15V3.44642L7.59771 1.3471C8.49597 1.07763 9.4 1.75025 9.4 2.68806V16.4H2C1.2268 16.4 0.6 15.7732 0.6 15Z"
            fill="white"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="7.2"
            y="5.24336"
            width="0.6"
            height="4.4"
            rx="0.3"
            transform="rotate(90 7.2 5.24336)"
            style={{ strokeWidth: 0.6 }}
          />
          <rect
            x="7.2"
            y="8.44258"
            width="0.6"
            height="4.4"
            rx="0.3"
            transform="rotate(90 7.2 8.44258)"
            style={{ strokeWidth: 0.6 }}
          />
          <rect
            x="7.2"
            y="11.6437"
            width="0.6"
            height="4.4"
            rx="0.3"
            transform="rotate(90 7.2 11.6437)"
            style={{ strokeWidth: 0.6 }}
          />
          <path
            d="M12 17.5C12.8672 17.5 13.6731 17.3836 14.2794 17.1814C14.58 17.0813 14.8593 16.9509 15.0737 16.782C15.2825 16.6174 15.5 16.3569 15.5 16C15.5 15.6431 15.2825 15.3826 15.0737 15.218C14.8593 15.0491 14.58 14.9187 14.2794 14.8186C13.6731 14.6164 12.8672 14.5 12 14.5C11.1328 14.5 10.3269 14.6164 9.72057 14.8186C9.42 14.9187 9.1407 15.0491 8.92627 15.218C8.71747 15.3826 8.5 15.6431 8.5 16C8.5 16.3569 8.71747 16.6174 8.92627 16.782C9.1407 16.9509 9.42 17.0813 9.72057 17.1814C10.3269 17.3836 11.1328 17.5 12 17.5Z"
            fill="white"
          />
          <path
            d="M12 15.5C12.8672 15.5 13.6731 15.3836 14.2794 15.1814C14.58 15.0813 14.8593 14.9509 15.0737 14.782C15.2825 14.6174 15.5 14.3569 15.5 14C15.5 13.6431 15.2825 13.3826 15.0737 13.218C14.8593 13.0491 14.58 12.9187 14.2794 12.8186C13.6731 12.6164 12.8672 12.5 12 12.5C11.1328 12.5 10.3269 12.6164 9.72057 12.8186C9.42 12.9187 9.1407 13.0491 8.92627 13.218C8.71747 13.3826 8.5 13.6431 8.5 14C8.5 14.3569 8.71747 14.6174 8.92627 14.782C9.1407 14.9509 9.42 15.0813 9.72057 15.1814C10.3269 15.3836 11.1328 15.5 12 15.5Z"
            fill="white"
          />
          <path
            d="M12 13.5C12.8672 13.5 13.6731 13.3836 14.2794 13.1814C14.58 13.0813 14.8593 12.9509 15.0737 12.782C15.2825 12.6174 15.5 12.3569 15.5 12C15.5 11.6431 15.2825 11.3826 15.0737 11.218C14.8593 11.0491 14.58 10.9187 14.2794 10.8186C13.6731 10.6164 12.8672 10.5 12 10.5C11.1328 10.5 10.3269 10.6164 9.72057 10.8186C9.42 10.9187 9.1407 11.0491 8.92627 11.218C8.71747 11.3826 8.5 11.6431 8.5 12C8.5 12.3569 8.71747 12.6174 8.92627 12.782C9.1407 12.9509 9.42 13.0813 9.72057 13.1814C10.3269 13.3836 11.1328 13.5 12 13.5Z"
            fill="white"
          />
          <path
            d="M12 11.5C12.8672 11.5 13.6731 11.3836 14.2794 11.1814C14.58 11.0813 14.8593 10.9509 15.0737 10.782C15.2825 10.6174 15.5 10.3569 15.5 10C15.5 9.64306 15.2825 9.3826 15.0737 9.21805C14.8593 9.04906 14.58 8.91874 14.2794 8.81855C13.6731 8.61643 12.8672 8.5 12 8.5C11.1328 8.5 10.3269 8.61643 9.72057 8.81855C9.42 8.91874 9.1407 9.04906 8.92627 9.21805C8.71747 9.3826 8.5 9.64306 8.5 10C8.5 10.3569 8.71747 10.6174 8.92627 10.782C9.1407 10.9509 9.42 11.0813 9.72057 11.1814C10.3269 11.3836 11.1328 11.5 12 11.5Z"
            fill="white"
          />
        </svg>
      );
    }
    if (iconNameVal === "AdminOverview") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classes["svg-AdminOverview"]}>
          <rect
            x="0.6"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="0.6"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="0.988672"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
          <rect
            x="9.26675"
            y="9.65664"
            width="6.13333"
            height="6.13333"
            rx="1.4"
            style={{ strokeWidth: 1.2 }}
          />
        </svg>
      );
    }
    if (iconNameVal === "AdminSettings") {
      return (
        <svg
          width="18"
          height="17"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.1763 7.21189H14.6794C14.4388 7.21189 14.2406 7.08607 14.1484 6.87496C14.0563 6.66385 14.1031 6.44148 14.2729 6.27991L15.3313 5.27474C15.4868 5.12696 15.5724 4.9302 15.5724 4.72134C15.5724 4.5122 15.4868 4.31573 15.3313 4.16767L13.9822 2.88608C13.6711 2.59053 13.1286 2.58997 12.8169 2.88608L11.7588 3.89126C11.5887 4.05254 11.3541 4.09758 11.1324 4.00976C10.9102 3.92222 10.7778 3.73391 10.7778 3.50534V2.0833C10.7778 1.65179 10.4083 1.30078 9.95407 1.30078H8.04593C7.5917 1.30078 7.22222 1.65179 7.22222 2.0833V3.50534C7.22222 3.73391 7.08978 3.92222 6.86756 4.00976C6.64593 4.09786 6.41126 4.05254 6.24119 3.89126L5.18311 2.88608C4.87141 2.58997 4.32889 2.59053 4.01778 2.88608L2.66874 4.16767C2.51319 4.31545 2.42756 4.5122 2.42756 4.72134C2.42756 4.9302 2.51319 5.12668 2.66874 5.27474L3.72711 6.27991C3.89689 6.44148 3.94341 6.66385 3.85156 6.87496C3.7597 7.08607 3.56119 7.21189 3.32059 7.21189H1.8237C1.36948 7.21189 1 7.5629 1 7.99441V9.80687C1 10.2387 1.36948 10.5897 1.8237 10.5897H3.32059C3.56119 10.5897 3.75941 10.7155 3.85156 10.9266C3.9437 11.1377 3.89689 11.3601 3.72711 11.5217L2.66874 12.5268C2.51319 12.6746 2.42756 12.8714 2.42756 13.0802C2.42756 13.2894 2.51319 13.4858 2.66874 13.6339L4.01778 14.9155C4.32919 15.2113 4.87141 15.2119 5.18311 14.9155L6.24119 13.91C6.41126 13.7487 6.64504 13.7043 6.86756 13.7918C7.08978 13.8793 7.22222 14.0677 7.22222 14.2962V15.7183C7.22222 16.1498 7.5917 16.5008 8.04593 16.5008H9.95378C10.408 16.5008 10.7775 16.1498 10.7775 15.7183V14.2962C10.7775 14.0677 10.9099 13.8793 11.1321 13.7918C11.3547 13.704 11.5884 13.7487 11.7585 13.91L12.8166 14.9155C13.1283 15.2116 13.6708 15.211 13.9819 14.9155L15.331 13.6339C15.4865 13.4861 15.5721 13.2894 15.5721 13.0802C15.5721 12.8714 15.4865 12.6749 15.331 12.5268L14.2726 11.5217C14.1028 11.3601 14.0563 11.1377 14.1481 10.9266C14.24 10.7155 14.4388 10.5897 14.6794 10.5897H16.1763C16.6305 10.5897 17 10.2387 17 9.80715V7.99441C17 7.5629 16.6305 7.21189 16.1763 7.21189ZM16.4074 9.80715C16.4074 9.92819 16.3037 10.0267 16.1763 10.0267H14.6794C14.1982 10.0267 13.7849 10.289 13.6009 10.7113C13.4166 11.1335 13.5135 11.5968 13.8539 11.92L14.9123 12.9251C15.0027 13.011 15.0027 13.1503 14.9123 13.2359L13.5633 14.5175C13.4732 14.603 13.3265 14.6036 13.2361 14.5175L12.1781 13.512C11.8376 13.1886 11.3502 13.0971 10.9058 13.2716C10.4613 13.4464 10.1852 13.8391 10.1852 14.2962V15.7183C10.1852 15.8393 10.0815 15.9378 9.95407 15.9378H8.04593C7.91852 15.9378 7.81482 15.8393 7.81482 15.7183V14.2962C7.81482 13.8391 7.53867 13.4464 7.09422 13.2716C6.94519 13.2128 6.7917 13.1841 6.64 13.1841C6.33956 13.1841 6.0483 13.2967 5.82193 13.5117L4.76385 14.5172C4.67319 14.6033 4.52652 14.6028 4.43674 14.5172L3.0877 13.2356C2.99733 13.1497 2.99733 13.0104 3.0877 12.9248L4.14607 11.9197C4.48622 11.5965 4.58341 11.1332 4.39911 10.711C4.21511 10.289 3.80178 10.0267 3.32059 10.0267H1.8237C1.6963 10.0267 1.59259 9.92819 1.59259 9.80715V7.99441C1.59259 7.87337 1.6963 7.77486 1.8237 7.77486H3.32059C3.80178 7.77486 4.21511 7.51251 4.39911 7.09029C4.58341 6.66807 4.48652 6.20475 4.14607 5.88161L3.0877 4.87644C2.99733 4.79059 2.99733 4.65126 3.0877 4.56568L4.43674 3.2841C4.52681 3.19825 4.67348 3.19825 4.76385 3.2841L5.82193 4.28927C6.16178 4.61213 6.64919 4.70474 7.09422 4.52966C7.53867 4.35514 7.81482 3.96247 7.81482 3.50534V2.0833C7.81482 1.96226 7.91852 1.86374 8.04593 1.86374H9.95378C10.0815 1.86374 10.1852 1.96226 10.1852 2.0833V3.50534C10.1852 3.96247 10.4613 4.35514 10.9058 4.52994C11.3508 4.70502 11.8379 4.61269 12.1781 4.28955L13.2361 3.28438C13.3268 3.19853 13.4735 3.19853 13.5633 3.28438L14.9123 4.56597C15.0027 4.65182 15.0027 4.79115 14.9123 4.87672L13.8539 5.88189C13.5138 6.20503 13.4166 6.66835 13.6009 7.09057C13.7849 7.5128 14.1982 7.77514 14.6794 7.77514H16.1763C16.3037 7.77486 16.4074 7.87337 16.4074 7.99441V9.80715Z"
            fill="#545454"
            style={{ strokeWidth: "0.4" }}
          />
          <path
            d="M8.99992 6.36719C7.5294 6.36719 6.33325 7.50353 6.33325 8.90052C6.33325 10.2975 7.5294 11.4339 8.99992 11.4339C10.4704 11.4339 11.6666 10.2975 11.6666 8.90052C11.6666 7.50353 10.4704 6.36719 8.99992 6.36719ZM8.99992 10.8709C7.85651 10.8709 6.92584 9.98676 6.92584 8.90052C6.92584 7.81428 7.85651 6.93015 8.99992 6.93015C10.1433 6.93015 11.074 7.81428 11.074 8.90052C11.074 9.98676 10.1433 10.8709 8.99992 10.8709Z"
            fill="#545454"
            style={{ strokeWidth: "0.4" }}
          />
        </svg>
      );
    }
    if (iconNameVal === "AdminCustomers") {
      return (
        <svg
          width="18"
          height="15"
          viewBox="0 0 18 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.25566 11.4609C8.25566 9.6384 9.73312 8.16094 11.5557 8.16094H14.0001C15.8227 8.16094 17.3001 9.6384 17.3001 11.4609V12.7292H8.25566V11.4609Z"
            style={{ strokeWidth: "1" }}
          />
          <path
            d="M14.6892 4.1033C14.6892 5.15878 13.8336 6.01441 12.7781 6.01441C11.7226 6.01441 10.867 5.15878 10.867 4.1033C10.867 3.04782 11.7226 2.19219 12.7781 2.19219C13.8336 2.19219 14.6892 3.04782 14.6892 4.1033Z"
            style={{ strokeWidth: "1" }}
          />
          <path
            d="M1.25566 11.4609C1.25566 9.6384 2.73312 8.16094 4.55566 8.16094H7.00011C8.82265 8.16094 10.3001 9.6384 10.3001 11.4609V12.7292H1.25566V11.4609Z"
            style={{ strokeWidth: "1" }}
          />
          <path
            d="M7.68921 4.1033C7.68921 5.15878 6.83358 6.01441 5.7781 6.01441C4.72263 6.01441 3.86699 5.15878 3.86699 4.1033C3.86699 3.04782 4.72263 2.19219 5.7781 2.19219C6.83358 2.19219 7.68921 3.04782 7.68921 4.1033Z"
            style={{ strokeWidth: "1" }}
          />
          <path
            d="M3.7 11.1113C3.7 9.28879 5.17746 7.81133 7 7.81133H11.4444C13.267 7.81133 14.7444 9.28879 14.7444 11.1113V13.5224H3.7V11.1113Z"
            fill="white"
            style={{ strokeWidth: "1" }}
            className={classes.AdminCustomersPathIcon}
          />
          <path
            d="M11.6333 3.11111C11.6333 4.44273 10.5538 5.52222 9.2222 5.52222C7.89058 5.52222 6.81108 4.44273 6.81108 3.11111C6.81108 1.77949 7.89058 0.7 9.2222 0.7C10.5538 0.7 11.6333 1.77949 11.6333 3.11111Z"
            fill="white"
            style={{ strokeWidth: "1" }}
            className={classes.AdminCustomersPathIcon}
          />
        </svg>
      );
    }
    if (iconNameVal === "AdminAccountants") {
      return (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.47224" cy="3.95418" r="3.25418" style={{ strokeWidth: "1.4" }} />
          <path
            className={classes.AdminAccountantsPathIcon}
            style={{ fillRule: "evenodd", clipRule: "evenodd", strokeWidth: "0" }}
            d="M13.7445 16.1604H15.1445V14.7604V11.5426C15.1445 10.2171 14.07 9.14258 12.7445 9.14258H4.20005C2.87457 9.14258 1.80005 10.2171 1.80005 11.5426V14.7604V16.1604H3.20005H13.7445ZM3.20005 11.5426C3.20005 10.9903 3.64776 10.5426 4.20005 10.5426H7.40774L8.06516 11.4187L6.00006 13.9993H10.9924L8.86398 11.4187L9.5214 10.5426H12.7445C13.2968 10.5426 13.7445 10.9903 13.7445 11.5426V13.3604V14.7604H12.3445H4.60005H3.20005V13.3604V11.5426Z"
            fill="black"
          />
        </svg>
      );
    }
    if (iconNameVal === "AdminBusiness") {
      return (
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.6 6.65664H13C14.3255 6.65664 15.4 7.73116 15.4 9.05664V15.4566H8.6V6.65664Z"
            style={{ strokeWidth: "1.2" }}
          />
          <path
            d="M0.6 2.05664C0.6 1.28344 1.2268 0.656641 2 0.656641H6.94117C7.71437 0.656641 8.34118 1.28344 8.34118 2.05664V15.4566H2C1.2268 15.4566 0.6 14.8298 0.6 14.0566V2.05664Z"
            style={{ strokeWidth: "1.2" }}
          />
          <rect
            x="6.2"
            y="4.3"
            width="0.6"
            height="3.4"
            rx="0.3"
            transform="rotate(90 6.2 4.3)"
            style={{ strokeWidth: "1.2" }}
          />
          <rect
            x="6.2"
            y="7.49922"
            width="0.6"
            height="3.4"
            rx="0.3"
            transform="rotate(90 6.2 7.49922)"
            style={{ strokeWidth: "1.2" }}
          />
          <rect
            x="6.2"
            y="10.7004"
            width="0.6"
            height="3.4"
            rx="0.3"
            transform="rotate(90 6.2 10.7004)"
            style={{ strokeWidth: "1.2" }}
          />
        </svg>
      );
    }
    if (iconNameVal === "PartnershipTax") {
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: "-3.5px", marginLeft: "-6px" }}>
          <rect
            x="7"
            y="1"
            width="24"
            height="30"
            rx="3"
            // stroke="#141414"
            style={{ strokeWidth: "2" }}
          />
          <rect
            x="23.5"
            y="10.5"
            width="1"
            height="10"
            rx="0.5"
            transform="rotate(90 23.5 10.5)"
            // stroke="#141414"
          />
          <rect
            x="23.5"
            y="16.5"
            width="1"
            height="10"
            rx="0.5"
            transform="rotate(90 23.5 16.5)"
            fill="white"
            // stroke="#141414"
          />
          <mask id="path-4-inside-1_2731_2777" fill="white">
            <path
              style={{ fillRule: "evenodd", clipRule: "evenodd" }}
              d="M25 25H0V29C0 31.2091 1.79086 33 4 33H28C30.2091 33 32 31.2091 32 29V25H30V27.5C30 28.8807 28.8807 30 27.5 30C26.1193 30 25 28.8807 25 27.5V25Z"
            />
          </mask>
          <path
            d="M25 25H0V29C0 31.2091 1.79086 33 4 33H28C30.2091 33 32 31.2091 32 29V25H30V27.5C30 28.8807 28.8807 30 27.5 30C26.1193 30 25 28.8807 25 27.5V25Z"
            fill="white"
            style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          />
          <path
            d="M0 25V23H-2V25H0ZM25 25H27V23H25V25ZM32 25H34V23H32V25ZM30 25V23H28V25H30ZM0 27H25V23H0V27ZM2 29V25H-2V29H2ZM4 31C2.89543 31 2 30.1046 2 29H-2C-2 32.3137 0.686291 35 4 35V31ZM28 31H4V35H28V31ZM30 29C30 30.1046 29.1046 31 28 31V35C31.3137 35 34 32.3137 34 29H30ZM30 25V29H34V25H30ZM30 27H32V23H30V27ZM28 25V27.5H32V25H28ZM28 27.5C28 27.7761 27.7761 28 27.5 28V32C29.9853 32 32 29.9853 32 27.5H28ZM27.5 28C27.2239 28 27 27.7761 27 27.5H23C23 29.9853 25.0147 32 27.5 32V28ZM27 27.5V25H23V27.5H27Z"
            fill="white"
            mask="url(#path-4-inside-1_2731_2777)"
          />
        </svg>
      );
    }

    return <></>;
  };
  return <ReturnIcon iconNameVal={iconName} />;
};

export default PersonalTaxImage;
